"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedPrefsFromSkuString = exports.supportedPrefsFromSku = exports.NEVER_SUPPORTED = exports.ALWAYS_SUPPORTED = void 0;
const effect_1 = require("effect");
const Sku = __importStar(require("./sku"));
const Technology = __importStar(require("./technology"));
const Water = __importStar(require("./water"));
exports.ALWAYS_SUPPORTED = [
    'language',
    'systemOfMeasure',
    'dripTrayFullCritical',
    'showFilterStatus',
    'betaFirmwareEnabled',
    'telemetryInterval',
    'stateInterval',
    'keepaliveInterval',
    'heartbeatInterval',
];
/** Hidden by product ("Hide - not handled"), not by SKU configuration. Not removed from the schema. */
exports.NEVER_SUPPORTED = ['loyaltyEnabled'];
const hasWaterTag = (waterTypes, tag) => waterTypes.some(waterType => waterType._tag === tag);
/**
 * Which `Prefs` fields a parsed SKU supports, per the "Unique Preferences Table".
 */
const supportedPrefsFromSku = (sku) => {
    const keys = new Set(exports.ALWAYS_SUPPORTED);
    const { waterTypes, technology, model } = sku;
    if (hasWaterTag(waterTypes, Water.TAGGED_TYPES.Hot._tag)) {
        keys.add('hotTemperature');
        keys.add('minimumHotTankTemperature');
        keys.add('hotEnabled');
    }
    if (hasWaterTag(waterTypes, Water.TAGGED_TYPES.Chilled._tag)) {
        keys.add('chilledTemperature');
        keys.add('coldEnabled');
    }
    if (hasWaterTag(waterTypes, Water.TAGGED_TYPES.ExtraHot._tag)) {
        keys.add('extraHotEnabled');
    }
    if (technology.pedal === Technology.PEDALS.Contactless) {
        keys.add('touchFreeEnabled');
    }
    // Only Best: confirmed by product in IOTPE-2001. A new top-tier model will need this rule extended.
    if (model === Sku.MODELS.BestFx && hasWaterTag(waterTypes, Water.TAGGED_TYPES.Sparkling._tag)) {
        keys.add('lightlySparklingEnabled');
    }
    return keys;
};
exports.supportedPrefsFromSku = supportedPrefsFromSku;
const decodeSku = effect_1.Schema.decodeEither(Sku.SkuStructFromSkuString);
/**
 * Decodes a GBFC SKU and returns the `Prefs` keys it supports.
 * `Option.none()` means the SKU couldn't be parsed - callers should show
 * a "couldn't determine preferences" state rather than falling back to the full list.
 */
const supportedPrefsFromSkuString = (raw) => {
    if (raw == null)
        return effect_1.Option.none();
    return (0, effect_1.pipe)(decodeSku(raw.trim()), effect_1.Either.map(exports.supportedPrefsFromSku), effect_1.Either.getRight);
};
exports.supportedPrefsFromSkuString = supportedPrefsFromSkuString;
//# sourceMappingURL=supported-prefs.js.map